<div *ngIf="IsActive" class="alert alert-warning" [innerHTML]="Body"></div>
